import { Card, Dialog, HStack, Portal, VStack } from '@chakra-ui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ReactNode, useState } from 'react';

const LeftModalButton = (props: { title: string; content?: ReactNode; children?: ReactNode }) => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root
      size={'full'}
      open={open}
      onOpenChange={(details) => {
        setOpen(details.open);
      }}
    >
      <Dialog.Trigger asChild>{props.children}</Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content data-closed={!open}>
            <Card.Root height="100%" display="flex" flexDirection="column">
              <Card.Header pb={4} borderBottomColor={'gray.200'} borderBottom={'1px solid'} flexShrink={0}>
                <HStack justifyContent={'space-between'}>
                  <Card.Title className="modal-btn__text" fontSize={'2xl'} fontWeight={'semibold'}>
                    {props.title}
                  </Card.Title>

                  <XMarkIcon
                    className="modal-btn__icon"
                    onClick={() => {
                      setOpen(false);
                    }}
                    style={{ width: '20px', cursor: 'pointer' }}
                  />
                </HStack>
              </Card.Header>
              <Card.Body px={0} py={0} flex={1} overflow="hidden">
                <VStack maxH={'90dvh'} align={'stretch'} overflow={'auto'} height="100%" gap={0}>
                  {props.content}
                </VStack>
              </Card.Body>
            </Card.Root>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default LeftModalButton;
